import { render, staticRenderFns } from "./BattleAcademiaMainSymbol.vue?vue&type=template&id=853dd644&"
import script from "./BattleAcademiaMainSymbol.vue?vue&type=script&lang=js&"
export * from "./BattleAcademiaMainSymbol.vue?vue&type=script&lang=js&"
import style0 from "./BattleAcademiaMainSymbol.vue?vue&type=style&index=0&id=853dd644&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports